import { render, staticRenderFns } from "./edit.data-loader-entities.page.vue?vue&type=template&id=0b80ae18&"
import script from "./edit.data-loader-entities.page.vue?vue&type=script&lang=js&"
export * from "./edit.data-loader-entities.page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports